import { useMutation } from '@apollo/client';
import { CurrencyRate } from '../../shared/types';
import { CITRIN_UPDATE_CURRENCY_RATES, UpdateCurrencyRatesRequest, UpdateCurrencyRatesResponse } from '..';

type UpdateMutationFunction = (request: CurrencyRate[]) => Promise<CurrencyRate[]>;
export const useUpdateCurrencyRateMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateCurrencyRatesResponse, UpdateCurrencyRatesRequest>(
        CITRIN_UPDATE_CURRENCY_RATES
    );

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateCurrencyRates;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
